import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteStoreApi } from "../../services/store/delete.store.api";

export const useDeleteStoreApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => deleteStoreApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-store"],
      });
    },
  });
};
